<template>
  <section
    class="banner-main"
    :class="{
        'banner-with-form': banner.shouldHaveForm,
        'banner-with-btn': !banner.shouldHaveForm && banner.button.text
      }"
    :style="[{ 'background-image': `url(${banner.image.link})`}, data.showModalForm && {'z-index': '1000'}]"
  >
    <FormModal
      v-if="banner.shouldHaveForm"
      :form="form"
      :successFormMessage="successFormMessage"
    />
    <div class="content container">
      <div class="row">
        <div
          class="col-12 headers d-flex flex-column justify-content-center"
          :class="{'col-lg-6': banner.shouldHaveForm,
                     'col-md-8': !banner.shouldHaveForm}"
        >
          <div>
            <h1 class="h1-light">{{ banner.title }}</h1>
            <p class="h2">{{ banner.description }}</p>
            <ButtonRed
              v-if="!banner.shouldHaveForm && banner.button.text"
              :text="banner.button.text"
              :href="banner.button.link"
              hyperlink
            />
            <ButtonRed
              v-if="data.shouldHaveModalButton && banner.shouldHaveForm"
              :text="banner.contactUsButton.text"
              class="w-100"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#bannerFormModal"
            />
          </div>
        </div>
        <div
          class="d-lg-flex flex-column"
          :class="{'d-none col-lg-6 align-items-end': banner.shouldHaveForm,
                     'd-flex flex-sm-row flex-md-column col-md-4 align-items-start': !banner.shouldHaveForm}"
        >
          <Form v-if="banner.shouldHaveForm" :form="form" :successFormMessage="successFormMessage"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Form from "@/components/banners/Form";
import FormModal from "@/components/banners/FormModal";
import ButtonRed from '@/components/common/ButtonRed';
import {handleListeners} from "@/utils/utils";
import {onMounted, onUnmounted, reactive} from "vue";

defineProps({
  banner: {
    title: String,
    description: String,
    button: {
      link: String,
      text: String
    },
    contactUsButton: {
      text: String,
    },
    image: {
      link: String,
      alt: String
    },
    shouldHaveForm: Boolean,
  },
  form: {
    firstName: {
      label: String,
      placeholder: String
    },
    lastName: {
      label: String,
      placeholder: String
    },
    email: {
      label: String,
      placeholder: String
    },
    phoneNumber: {
      label: String,
      placeholder: String
    },
    company: {
      label: String,
      placeholder: String
    },
    city: {
      label: String,
      placeholder: String
    },
    state: {
      label: String,
      placeholder: String
    },
    inquiry: {
      label: String,
      placeholder: String,
      options: [String]
    },
    checkbox: String,
    button: {
      text: String
    },
    countries: [
      {
        name: String,
        states: [String]
      }
    ]
  },
  successFormMessage: {
    title: String,
    description: String,
  }
});

const data = reactive({
  shouldHaveModalButton: false,
  showModalForm: false
});

const handleScreenWidth = () =>
  data.shouldHaveModalButton = window.matchMedia('(max-width: 992px)').matches;

handleScreenWidth();
onMounted(() => handleListeners(['resize'], handleScreenWidth));
onUnmounted(() => handleListeners(['resize'], handleScreenWidth, true));
</script>
